import React, { useContext, useEffect, useState } from "react";
import cx from "classnames";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";

import global from "../../../scss/dhp.scss";

import { Icon } from "../../ui/icon";
import { EditorContext } from "../../../containers/editor/EditorLayout";
import useButtonAnimations from "../../../hooks/useButtonAnimations";

let style = Object.assign({}, global);

const ButtonAnimation = () => {
  let { metadata, widgets, updateWidgets } = useContext(EditorContext);
  let { createRipple, createPulse, createSpinner } = useButtonAnimations();

  let interval = null;
  let pulseEl = null;
  let spinnerEl = null;

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [animationDropdown, setAnimationDropdown] = useState(false);
  const [animationStyle, setAnimationStyle] = useState();

  const availableAnimationStyles = ["None", "Pulse", "Ripple", "Spinner"];

  const toggleDropDown = () => setDropdownOpen(prevState => !prevState);

  const toggle = () => setAnimationDropdown(prevState => !prevState);

  const handleAnimationClick = animation => {
    setAnimationStyle(animation);
    playAnimation(animation);

    //update widget
    let isGroupWidget = document.getElementById(metadata.activeWidgetId[0])?.closest(".dhp-page-group");
    let targetId = isGroupWidget
      ? document.getElementById(id).closest(".dhp-root-widget").getAttribute("id")
      : metadata.activeWidgetId[0];
    let targetWidgetIndex = widgets.findIndex(widget => widget.id === targetId);
    let newArray = Object.assign([...widgets]);
    newArray = Object.assign([...newArray], {
      [targetWidgetIndex]: {
        ...newArray[targetWidgetIndex],
        data: {
          ...newArray[targetWidgetIndex].data,
          "data-button-animation": animation,
        },
      },
    });
    updateWidgets(newArray);
  };

  const playAnimation = animation => {
    const button = document.querySelector(`#${metadata.activeWidgetId[0]} .dhp-widget-inner`);
    document.getElementById("dhp-widget-handler").style.display = "none";

    // prevent multiple intervals
    if (interval || pulseEl || spinnerEl || animation === "None") return;

    //Ripple effect
    if (animation === "Ripple") {
      const el = document.querySelector(`#${metadata.activeWidgetId[0]} .dhp-widget-inner`);

      el.style.overflow = "hidden";
      el.style.position = "relative"; // ✅ VERY IMPORTANT

      interval = setInterval(() => {
        createRipple(button);
      }, 500);
    }

    //Pulse effect
    if (animation === "Pulse") {
      pulseEl = createPulse(button, "editor");
    }

    //Spinner effect
    if (animation === "Spinner") {
      spinnerEl = createSpinner(button);
    }

    // ⛔ stop after 5 seconds
    setTimeout(() => {
      if (interval) {
        clearInterval(interval);
        interval = null;
      }

      if (pulseEl) {
        pulseEl.remove();
        pulseEl = null;
      }

      if (spinnerEl) {
        spinnerEl.remove();
        spinnerEl = null;
      }
      document.getElementById("dhp-widget-handler").style.display = "block";
    }, 5000);
  };

  // load current formatting
  useEffect(() => {
    setAnimationStyle(document.querySelector(`#${metadata.activeWidgetId[0]}`).getAttribute("data-button-animation"));
  }, [metadata.activeWidgetId]);

  return (
    <li className={cx(style["toolset-group"])}>
      <UncontrolledDropdown
        className={cx(style["toolset-item"], style["animation-wrap"])}
        isOpen={dropdownOpen}
        toggle={toggleDropDown}>
        <DropdownToggle tag="a" className={cx(style["toolset-action"], style["custom-tooltip"])}>
          <Icon icon="ui-buttons" />
          <div className={cx(style["custom-tooltip-content"], style["top"])}>Button Animation</div>
        </DropdownToggle>
        <DropdownMenu className={cx(style["shadow"], style["border-0"], style["rounded"], style["w-auto"])}>
          <div className={cx(style["line-controls-wrap"], style["p-0"], style["mb-0"])}>
            <div className={cx(style["slidelabel"], style["p-0"])}>Animation</div>
            <Dropdown isOpen={animationDropdown} toggle={toggle} className={cx(style["border-style"], style["mx-3"])}>
              <DropdownToggle className={style["text-capitalize"]}>
                {animationStyle}
                <Icon icon="ui-arrow-down" />
              </DropdownToggle>

              <DropdownMenu className={cx(style["shadow"], style["border-0"], style["rounded"])}>
                {availableAnimationStyles.map(availableAnimationStyle => (
                  <React.Fragment key={availableAnimationStyle}>
                    <DropdownItem
                      className={cx(style["text-capitalize"], {
                        [style["active"]]: availableAnimationStyle === animationStyle,
                      })}
                      tag="a"
                      onClick={() => handleAnimationClick(availableAnimationStyle)}>
                      {/* <span className={availableAnimationStyle}></span> */}
                      {availableAnimationStyle}
                    </DropdownItem>
                  </React.Fragment>
                ))}
              </DropdownMenu>
            </Dropdown>
            <span
              className={cx(style["custom-tooltip"], style["d-flex"], style["cursor-pointer"])}
              onClick={() => playAnimation(animationStyle)}>
              <Icon icon="ui-play2" />
              <div className={cx(style["custom-tooltip-content"], style["top"])}>Play</div>
            </span>
          </div>
        </DropdownMenu>
      </UncontrolledDropdown>
    </li>
  );
};

export default ButtonAnimation;
